import React , {useState, useEffect} from 'react';
import {useForm} from 'react-hook-form';
import clinicService from '../../../../../services/clinic.service';
import userService from '../../../../../services/user.service';
import {toast} from 'react-toastify'

const ClinicUserReminderSettingsForm = (props) => {
    const {register, handleSubmit, reset, formState: {errors}} = useForm(
        {
            defaultValues: props.reminderSettings
        }
    );
    const [isLoading, setIsLoading] = useState(false);
    const updateSettings = props.updateSettings
    const [reminderSettings, setReminderSettings] = useState({});

    useEffect(() => {
        setReminderSettings(props.reminderSettings);
        console.log(props.reminderSettings)
    }, [props.reminderSettings]);

    const onSubmit = (data) => {
        setIsLoading(true);
        const avoidKeys= ["reminderTime","sameDayReminderTime","daysPrebookReminder","daysFirstReminder","minutesToAppt","createdAt","modifiedAt","clinicId","id","userId"]
        for(const key in data){
           if(!avoidKeys.includes(key)){
            data[key]? data[key] = 1: data[key] = 0;
           }
        }
       
        userService.updateUserReminderSettings(props.user.clinicId,props.user.id, data)
            .then(res => {
               
                setIsLoading(false);
                setReminderSettings(res.data);
                updateSettings(res.data)
                toast.success("Updated Reminder Settings",{
                  position:toast.POSITION.BOTTOM_RIGHT
                })
                
            })
            .catch(err => {
                setIsLoading(false);
               toast.error("Error while updating Settings",{
                  position:toast.POSITION.BOTTOM_RIGHT
               })
            });
    };

const getClinicReminders = ()=>{
  clinicService.getReminderSettings(props.user.clinicId)
  .then(res=>{
    console.log("Clinic Reminders")
    const newVal = {
      "apptReminder":  res.data.apptReminder, 
      "reminderTime":  res.data.reminderTime,
      "sameDayReminderTime":  res.data.sameDayReminderTime,
      "isPrebookedReminder":  res.data.isPrebookedReminder,
      "isFirstReminder":  res.data.isFirstReminder,
      "isSecondReminder":  res.data.isSecondReminder,
      "isLastReminder":  res.data.isLastReminder,
      "isSameDayReminder":  res.data.isSameDayReminder,
      "daysPrebookReminder":  res.data.daysPrebookReminder,
      "daysFirstReminder":  res.data.daysFirstReminder,
      "daysSecondReminder":  res.data.daysSecondReminder,
      "minutesToAppt":  res.data.minutesToAppt,
      "isClReminder":  res.data.isClReminder,
      "isClReorder":  res.data.isClReorder,
      "isBirthday":  res.data.isBirthday,
      "isThankyou":  res.data.isThankyou,
      "isWelcome":  res.data.isWelcome,
      "isEmail":  res.data.isEmail,
      "isSms":  res.data.isSms,
      "isCall":  res.data.isCall,
      "isApptSummary":  res.data.isApptSummary,
      "isClGlSummary":  res.data.isClGlSummary,
      "apptSummary":  res.data.apptSummary,
      "callPreference":  res.data.callPreference,
      "isGlPickup":  res.data.isGlPickup,
      "isClPickup":  res.data.isClPickup,
      "isFollowup":  res.data.isFollowup
    }
    reset(newVal)
    toast.success("Values Changed to Default Clinics. Save to Continue",{
      position:toast.POSITION.BOTTOM_RIGHT
    })
   
  })
  .catch(err=>{
    toast.error("Error while updating Settings",{
      position:toast.POSITION.BOTTOM_RIGHT
   })
    console.log(err)
  })
}
    return ( 
        <>
        <div className="d-flex justify-content-end">
            <button className="btn btn-sm btn-warning" onClick={getClinicReminders}>Reset To Clinic Settings</button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-md-6">
                 <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("apptReminder")}
                        />
                      <label htmlFor="apptReminder" className="form-check-label">Appointment Reminders</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isPrebookedReminder")}
                        />
                      <label htmlFor="isPrebookedReminder" className="form-check-label">Prebooked Reminders</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isFirstReminder")}
                        />
                      <label htmlFor="isFirstReminder" className="form-check-label">First Reminders</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isSecondReminder")}
                        />
                      <label htmlFor="isSecondReminder" className="form-check-label">Second Reminders</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isLastReminder")}
                        />
                      <label htmlFor="isLastReminder" className="form-check-label">Last Reminders</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isSameDayReminder")}
                        />
                      <label htmlFor="isSameDayReminder" className="form-check-label">Same Day Reminders</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isClReminder")}
                        />
                      <label htmlFor="isClReminder" className="form-check-label">Contact Lens Reminders</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isClReorder")}
                        />
                      <label htmlFor="isClReorder" className="form-check-label">Contact Lens Reorder</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isBirthday")}
                        />
                      <label htmlFor="isBirthday" className="form-check-label">Birthday Reminders</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isThankyou")}
                        />
                      <label htmlFor="isThankyou" className="form-check-label">Thank you Reminder</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isWelcome")}
                        />
                      <label htmlFor="isWelcome" className="form-check-label">Welcome Reminders</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isEmail")}
                        />
                      <label htmlFor="isEmail" className="form-check-label">Email Reminder</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isSms")}
                        />
                      <label htmlFor="isSms" className="form-check-label">Sms Reminders</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isCall")}
                        />
                      <label htmlFor="isCall" className="form-check-label">Call Reminders</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("apptSummary")}
                        />
                      <label htmlFor="apptSummary" className="form-check-label">Appointment Summary</label>
                  </div>
                  <div className="form-check form-switch ms-3">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isClGlSummary")}
                        />
                      <label htmlFor="isClGlSummary" className="form-check-label">Contact Lens & Glass Summary</label>
                  </div>
            </div>
            <div className="col-md-6">
               
               <div className="row">
                   <div className="col-12 mb-3">
                       <label htmlFor="reminderTime" className="form-label"> Reminder Time</label>
                       <input
                            type="time"
                            className="form-control"
                            {...register("reminderTime")}
                            />
                   </div>
                   <div className="col-12 mb-3">
                       <label htmlFor="sameDayReminderTime" className="form-label"> Same Day Reminder Time</label>
                       <input
                            type="time"
                            className="form-control"
                            {...register("sameDayReminderTime")}
                            />
                   </div>
                   <div className="col-12 mb-3">
                       <label htmlFor="" className="form-label"> Days To Send Prebook Reminder</label>
                       <input
                            type="number"
                            className="form-control"
                            {...register("daysPrebookReminder")}
                            />
                   </div>
                   <div className="col-12">
                       <label htmlFor="" className="form-label"> Days to Send First Reminder</label>
                       <input
                            type="number"
                            className="form-control"
                            {...register("daysFirstReminder")}
                            />
                   </div>
                   <div className="col-12">
                       <label htmlFor="" className="form-label"> Days to Send Second Reminder</label>
                       <input
                            type="number"
                            className="form-control"
                            {...register("daysSecondReminder")}
                            />
                   </div>
                   <div className="col-12">
                       <label htmlFor="" className="form-label"> Minutes Earlier</label>
                       <input
                            type="number"
                            className="form-control"
                            {...register("minutesToAppt")}
                            />
                   </div>
               </div>
            </div>
            <div className="col-12 text-center mt-3">
                    <button className="btn btn-secondary" type="submit">Save</button>
            </div>
        </form>
        </>
     );
}
 
export default ClinicUserReminderSettingsForm;